module.exports = __webpack_public_path__ + "img/pause.3097c79c.svg";